var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * SocialTwitter icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSocialTwitter extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.9812 4.39901C19.3715 2.65773 16.6973 1.86308 14.4889 2.43202C13.3011 2.73803 12.2256 3.44598 11.5487 4.62961C10.9775 5.62829 10.7242 6.90499 10.8595 8.45304C10.4752 8.43115 9.94808 8.36295 9.30531 8.18649C7.81985 7.77868 5.68536 6.784 3.25167 4.39187C3.03317 4.17636 2.75752 4.02792 2.45732 3.9641C2.15685 3.90023 1.84437 3.9238 1.55688 4.03203C1.2694 4.14026 1.01895 4.32861 0.835204 4.57478C0.665696 4.80187 0.559503 5.0694 0.526792 5.35004C-0.0314033 7.69859 0.260263 10.1696 1.35111 12.3244C2.2512 14.1024 3.64698 15.5693 5.35661 16.5563C4.46914 17.1042 3.50549 17.5225 2.49476 17.7966C2.47464 17.802 2.45476 17.8083 2.43516 17.8154C2.1249 17.9281 1.85683 18.1335 1.6674 18.4037C1.47796 18.674 1.37633 18.9961 1.37633 19.3262C1.37633 19.6562 1.47796 19.9783 1.6674 20.2486C1.85344 20.514 2.1153 20.7169 2.41849 20.8307C8.52555 23.3334 13.6572 22.6936 17.1364 20.1946C20.5468 17.745 22.2414 13.5949 21.7205 9.25152L23.5436 5.47508C23.6558 5.24266 23.6406 4.96888 23.5034 4.7503C23.3662 4.53171 23.1263 4.39901 22.8682 4.39901H20.9812ZM11.7082 9.17759L11.8398 9.91595C12.2446 9.84379 12.5158 9.45922 12.4479 9.05372C12.1634 7.35474 12.3965 6.1685 12.8507 5.37431C13.3004 4.58812 14.0131 4.10357 14.8632 3.88459C16.6167 3.43282 18.8539 4.14341 20.058 5.62251C20.2004 5.79746 20.414 5.89901 20.6396 5.89901H21.6733L20.2728 8.8001C20.2086 8.93309 20.1851 9.08208 20.2052 9.22838C20.7449 13.1514 19.2414 16.8358 16.2614 18.9763C13.2929 21.1084 8.72623 21.798 2.9758 19.438C2.96625 19.4341 2.95662 19.4304 2.94692 19.4269C2.92624 19.4194 2.90837 19.4057 2.89574 19.3877C2.88311 19.3696 2.87633 19.3482 2.87633 19.3262C2.87633 19.3042 2.88311 19.2827 2.89574 19.2647C2.90529 19.251 2.91784 19.2399 2.93234 19.232C4.51479 18.7965 5.99477 18.05 7.28574 17.036C7.49504 16.8716 7.60154 16.6086 7.5656 16.3449C7.52966 16.0812 7.35666 15.8563 7.111 15.7539C5.19495 14.9553 3.62696 13.4989 2.68938 11.6469C1.75181 9.79489 1.50625 7.66899 1.99693 5.65201C2.0068 5.61143 2.01327 5.5701 2.01626 5.52844C2.01773 5.50802 2.02502 5.48844 2.03727 5.47203C2.04952 5.45561 2.06621 5.44306 2.08538 5.43584C2.10454 5.42863 2.12537 5.42706 2.14541 5.43131C2.16544 5.43557 2.18383 5.44548 2.1984 5.45987L2.19957 5.46102C4.80563 8.02276 7.16235 9.15367 8.9082 9.63297C9.77851 9.8719 10.4894 9.94678 10.9941 9.95975C11.2463 9.96623 11.4467 9.95724 11.5896 9.94566C11.661 9.93986 11.718 9.93342 11.7599 9.92794C11.7809 9.92519 11.7981 9.92269 11.8115 9.92062L11.8286 9.91788L11.8349 9.9168L11.8375 9.91635L11.8387 9.91614C11.8393 9.91604 11.8398 9.91595 11.7082 9.17759Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSocialTwitter.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSocialTwitter.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSocialTwitter.prototype, "size", void 0);
if (customElements.get('cat-icon-social-twitter') === undefined) {
    customElements.define('cat-icon-social-twitter', BlocksIconSocialTwitter);
}
